import { useContext, useEffect, useRef, useState } from "react";
import styles from "./Mpesa.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./screens/Details";
import { BackToMethods } from "../../common/BackToMethods";
import { WalletPayProps } from "../Wallet";
import axios from "axios";
import { checkTransactionStatus, closeTab, sendMessage } from "../../../context/utils";
import { StatusContext } from "../../../context/Status";
import { StatusMessage } from "../../StatusMessage";
import { ErrorAlertContext } from "../../../context/ErrorAlert";
import { Option } from "../../common/KlashaSelect";
import { Instructions } from "./screens/Instructions";
import { Processing } from "../../common/Processing";
import {Otp} from "../Card/screens/Otp";
import Loader from "../../common/Loader";
import { extractRedirectionLink } from "../../../utils/helperFunctions";
import { mobileMoneyInstructionMap } from "../../../utils/constants";

export const MobileMoneyMethod = () => {
  const { email, currency, amount, payData, merchantKey  } =
    useContext(RoutingContext);
  const { pageTransactionStatus, setPageTransactionStatus } =
    useContext(StatusContext);
  const { onShowAlert } = useContext(ErrorAlertContext);

  const [isLoading, setIsLoading] = useState(false);
  const [tabDisplayed, setTabDisplayed] = useState("details");
  const [selectedNetwork, setSelectedNetwork] = useState("SK");
  const [mobileTnxRef, setMobileTnxRef] = useState("");
  const [mobileTnxId, setMobileTnxId] = useState("");
  const [instruction, setInstruction] = useState("");
  const [statusCustomMessage, setStatusCustomMessage] = useState("");
  const [availableNetworks, setAvailableNetworks] = useState<Option[]>([]);
  const [emailError, setEmailError] = useState("");
  let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const [transRef, setTransRef] = useState("");

  const mobileMoneyBaseURL =  `${process.env.REACT_APP_API_URL}pay/${currency}/mobilemoney/v2`
  const redirectUrl = `${process.env.REACT_APP_REDIRECT_URL}`

  const handleRedirectError = () => {
    setTabDisplayed("error");
    setPageTransactionStatus("error");
    setTimeout(() => {
      sendMessage({ status: "ERROR",  tnxRef: payData.kit.tx_ref });
    }, 1000);
  };

  useEffect(() => {
    //Todo: Put in a constant
    const networkMapping: Record<string, { value: string; label: string }[]> = {
      XOF: [
        { value: "mtn", label: "MTN" },
        { value: "moov", label: "Moov" },
        { value: "orange", label: "Orange" },
        { value: "wave", label: "Wave" },
      ],
      XAF: [
        { value: "mtn", label: "MTN" },
        { value: "orange", label: "Orange" },
      ],
      CDF: [
        { value: "airtel", label: "Airtel" },
        { value: "mtn", label: "MTN" },
      ],
      KES: [
        { value: "mpesa", label: "Mpesa" },
      ],
      MWK: [
        { value: "airtel", label: "Airtel" },
        { value: "tnm", label: "TNM" },
      ],
      SLL: [
        { value: "orange", label: "Orange" },
      ],
      ZMW: [
        { value: "mtn", label: "MTN" },
        { value: "airtel", label: "Airtel" },
        { value: "zamtel", label: "Zamtel" },
      ],
      CDR: [
        { value: "airtel", label: "Airtel" },
        { value: "orange", label: "Orange" },
        { value: "vodacom", label: "Vodacom" },
      ],
      RWF: [
        { value: "mtn", label: "MTN" },
        { value: "airtel", label: "Airtel" },
      ],
      TZS: [
        { value: "tigo", label: "Tigo" },
        { value: "airtel", label: "Airtel" },
        { value: "halotel", label: "Halotel" },
      ],
      UGX: [
        { value: "mtn", label: "MTN" },
        { value: "airtel", label: "Airtel" },
      ],
      GHS: [
        { value: "mtn", label: "MTN" },
        { value: "vodafone", label: "Vodafone" },
        { value: "tigo", label: "Tigo" },
      ]
    };

    const availableNetworks = networkMapping[currency] || [];
    setAvailableNetworks(availableNetworks);
  }, [currency]);

  const cancelledRef = useRef(false);

  useEffect(() => {
    return () => {
      cancelledRef.current = true;
    };
  }, []);


  const onPay = async (data?: WalletPayProps) => {
    let payload = {
      ...payData.kit,
      phone_number: data?.phone || payData.kit?.phone_number,
      email: data?.email || payData.kit?.email,
      network: selectedNetwork,
      fullname: data?.fullname || payData.kit?.fullname,
      productType: payData.kit.productType ?? "COLLECTION",
      amount: payData.amount,
      currency: payData.currency,
      sourceCurrency: payData.sourceCurrency,
      countryCode: payData.countryCode,
      call: payData.call,
      merchantKey: payData.merchantKey,
      tx_ref: payData.kit.tx_ref,
      description: "merchant payment",
      hideCloseBtn: payData.hideCloseBtn,
      rememberMe: false,
      redirect_url: redirectUrl,
    };

    if (!data?.email || !data?.email.match(mailformat)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: mobileMoneyBaseURL,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": merchantKey,
          ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
            "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN,
          }),
        },
        data: payload,
      });

      const responseData = response?.data;

      if (responseData?.status === "error") {
        const errorMessage =
            responseData?.message || responseData?.error || "An unknown error occurred.";
        onShowAlert(responseData, "Payment failed: " + errorMessage);

        setTabDisplayed("error");
        setPageTransactionStatus("error");
        setTimeout(() => {
          sendMessage({ status: "ERROR" });
        }, 10000);
        return;
      }

      const redirectLink = extractRedirectionLink(responseData);

      if (redirectLink) {
        setIsLoading(false);
        try {
          const newTab = window.open(redirectLink, '_blank');
          if (newTab) {
            newTab.opener = null;
          }
          setTimeout(() => {
            sendMessage({status: "Success", tnxRef: payData.kit.tx_ref});
            closeTab(); 
          }, 100); 
        } catch (error) {
          handleRedirectError();
        }

        return
      }

      const message = data?.processor_response;
      setTabDisplayed("instructions");
      setInstruction(mobileMoneyInstructionMap[currency] ?? message);

      if (responseData?.data?.status === "pending") {
        const POLL_INTERVAL_MS = 10 * 1000;       
        const MAX_POLL_DURATION_MS = 2 * 60 * 1000; 
        const TERMINAL_STATES = ["success", "error", "failed"];

        const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
          if (cancelledRef.current) return clearInterval(intervalId);
          checkTransactionStatus(
            payData.kit.tx_ref,
            merchantKey,
            (status: string) => {
              setTabDisplayed(status);

              if (TERMINAL_STATES.includes(status)) {
                clearInterval(intervalId);
                clearTimeout(timeoutId);
              }
            }
          );
        }, POLL_INTERVAL_MS);

        const timeoutId: ReturnType<typeof setTimeout> = setTimeout(() => {
          if (cancelledRef.current) return;
          clearInterval(intervalId);
          setStatusCustomMessage("Transaction status not confirmed. Do not retry, to avoid duplicate charges. Please check with the merchant.");
          setTabDisplayed("pending");
          setTimeout(() => {
            if (cancelledRef.current) return;
            sendMessage({ status: "PENDING", tnxRef: payData.kit.tx_ref });
          }, 10000);
        }, MAX_POLL_DURATION_MS);
      }

      setMobileTnxRef(payData?.kit.tx_ref);
      setMobileTnxId(data?.id);

      setTabDisplayed("codesent");
      setPageTransactionStatus("codesent");
      setIsLoading(false);
    } catch (error: any) {
      const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "A network error occurred. Please try again.";
      onShowAlert(error, "Payment failed: " + errorMessage);

      setIsLoading(false);
      setTabDisplayed("error");
      setPageTransactionStatus("error");
      setTimeout(() => {
        sendMessage({ status: "ERROR" });
      }, 10000);
    }
  };



  const onOTPComplete = async (otpValue: string) => {
    const payload = {
      otp: otpValue,
      tx_ref: payData.kit.tx_ref,
    };

    try {
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: mobileMoneyBaseURL,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": merchantKey,
          ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
            "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
          })

        },
        data: payload,
      });

      const responseData = response.data;

      if (responseData["status"] === "error") {
        onShowAlert(
            responseData,
            "Payment failed please try again: " + responseData["message"]
        );
        setIsLoading(false);
        return;
      }

      const data = responseData.data;
      const message = data.processor_response;
      setTabDisplayed("instructions");
      setInstruction(message);
      setMobileTnxRef(data.tx_ref);
      setMobileTnxId(data.id);

      if(data.status === "pending") {
        setTabDisplayed("success");
        setPageTransactionStatus("success");
      }else{
        setTabDisplayed("codesent");
        setPageTransactionStatus("codesent")

      }

      setIsLoading(false);

    } catch (error) {
      onShowAlert(error, "Please try again");
      setIsLoading(false);
      setTabDisplayed("error");
      setPageTransactionStatus("error");
      setTimeout(() => {
        sendMessage({ status: "ERROR" });
      }, 10000);
    }
  };


  const onPaid = async () => {
    if (mobileTnxRef !== "") {
      const payload = {
        tnxId: mobileTnxId,
        orderId: mobileTnxId,
      };

      try {
        setIsLoading(true);
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}pay/${currency}/payment/verify`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
            ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
              "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
            })
          },
          data: payload,
        });
        const responseData = response.data;

        if (responseData["status"] === "successful") {
          setTabDisplayed("success");
          setPageTransactionStatus("success");
        } else if (
          responseData["status"] === "success" ||
          responseData["message"] === "pending"
        ) {
          setPageTransactionStatus("processing");
        } else {
          setTabDisplayed("error");
          setPageTransactionStatus("error");
          // onShowAlert("Payment failed please try again: " + data['status'])
        }

        setTransRef(responseData.data.tx_ref);
        const set = {
          status: responseData.status,
          tnxRef: responseData.tnx_ref,
          txnRef: responseData.tnx_ref,
          tx_ref: responseData.tnx_ref,
          amount: responseData.amount,
        };
        setIsLoading(false);
        setTimeout(() => {
          sendMessage(set);
        }, 10000);
      } catch (error) {
        onShowAlert(error, "Please try again");
        setIsLoading(false);
        setTabDisplayed("error");
        setPageTransactionStatus("error");
      }
    }
  };

  const onNetworkChange = (option: any) => {
    setSelectedNetwork(option.value);
  };

  if (tabDisplayed === "error" || tabDisplayed === "success" || tabDisplayed === "pending") {
    return <StatusMessage type={tabDisplayed} message={statusCustomMessage}/>;
  }

  return (
    <MobileWrapper>
       <Loader isLoading={isLoading} />
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            {pageTransactionStatus === "idle" && tabDisplayed === "details" && (
              <Details
                networks={availableNetworks}
                onPay={onPay}
                onNetworkChange={onNetworkChange}
                defaultName={payData.kit.fullname}
                defaultPhone={payData.kit?.phone_number}
                defaultEmail={payData.kit?.email}
                isLoading={isLoading}
                isNetworkDisabled={selectedNetwork?.length === 2}
                emailError={emailError}
                setEmailError={setEmailError}
              />
            )}
            {pageTransactionStatus === "processing" && (
              <Processing
                transactionRef={transRef}
                setTabDisplayed={setTabDisplayed}
              />
            )}
          </div>
          {}

          {/*Todo: Combine into  a utils. There's plan to switch to a new api so will be handy to do async*/}
          { pageTransactionStatus === "codesent" && currency === "ZMW" && <Otp onSubmit={onOTPComplete}  message="" />
          }
          {pageTransactionStatus === "codesent"  && currency !== "ZMW" && (
            <Instructions
              instructions={instruction}
              onPaid={onPaid}
              isLoading={isLoading}
              isPaymentPending={currency !== "ZMW"}
            />
          )}

          {pageTransactionStatus !== "processing" && <BackToMethods />}
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
